// @flow
import React, { Component } from 'react'
import { calcGreeks } from '../../services/risk'
import { StyledTable, StyledRow } from './style'
import { Card, Form, Input, Button, Col } from 'antd'
const FormItem = Form.Item

type Props = {
  form: Form
}

type State = {
  greeks: Object[],
  form: Object
}

const initialState: State = {
  greeks: [{
    key: '1',
    title: 'Option Price',
    call: '0',
    put: '0'
  }, {
    key: '2',
    title: 'Delta',
    call: '0',
    put: '0'
  }, {
    key: '3',
    title: 'Gamma',
    call: '0',
    put: '0'
  }, {
    key: '4',
    title: 'Vega',
    call: '0',
    put: '0'
  }, {
    key: '5',
    title: 'Theta',
    call: '0',
    put: '0'
  }],
  form: {
    assetPrice: '0',
    strikePrice: '0',
    expireDay: '0',
    riskFree: '0',
    dividendYield: '0',
    volatility: '0',
    ds: '0',
    rounding: '0'
  }
}

class CalculatorGreeksForm extends Component<Props, State> {

  state: State = {
    greeks: initialState.greeks,
    form: initialState.form
  }

  handleSubmit = (e: Object) => {

    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (!err) {

        const { callResult, putResult} = calcGreeks(values)

        const greeks: Object[] = [{
          key: '1',
          title: 'Option Price',
          call: callResult.optionValue,
          put: putResult.optionValue
        }, {
          key: '2',
          title: 'Delta',
          call: callResult.delta,
          put: putResult.delta
        }, {
          key: '3',
          title: 'Gamma',
          call: callResult.gamma,
          put: putResult.gamma
        }, {
          key: '4',
          title: 'Vega',
          call: callResult.vega,
          put: putResult.vega
        }, {
          key: '5',
          title: 'Theta',
          call: callResult.theta,
          put: putResult.theta
        }]

        this.setState({ greeks })
      }
    })
  }

  handleReset = () => {

    // reset greeks and form to initial state
    this.setState({ 
      greeks: initialState.greeks,
      form: initialState.form
    })

    this.props.form.resetFields()
  }

  render() {

    // --- Props and State ---
    const { getFieldDecorator } = this.props.form
    const { form, greeks } = this.state

    // --- Form ---
    const formItemLayout: Object = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }

    // --- Table ---
    const columns: Object[] = [{
      title: '',
      dataIndex: 'title',
      key: 'title'
    }, {
      title: 'Call Option',
      dataIndex: 'call',
      key: 'call'
    }, {
      title: 'Put Option',
      dataIndex: 'put',
      key: 'put'
    }]

    return (
      <Card bordered={false} title='Greeks'>

        <StyledTable
          columns={columns}
          dataSource={greeks}
          pagination={false}
          size='small'
          bordered />
                  
        <Form onSubmit={this.handleSubmit}>

          <FormItem {...formItemLayout} label='Asset Price'>
            {getFieldDecorator('assetPrice', {
              initialValue: form.assetPrice,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Strike Price'>
            {getFieldDecorator('strikePrice', {
              initialValue: form.strikePrice,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Expiration'>
            {getFieldDecorator('expireDay', {
              initialValue: form.expireDay,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Risk Free Rate'>
            {getFieldDecorator('riskFree', {
              initialValue: form.riskFree,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Dividend Yield'>
            {getFieldDecorator('dividendYield', {
              initialValue: form.dividendYield,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Volatility'>
            {getFieldDecorator('volatility', {
              initialValue: form.volatility,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='ds'>
            {getFieldDecorator('ds', {
              initialValue: form.ds,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='rounding'>
            {getFieldDecorator('rounding', {
              initialValue: form.rounding,
              rules: []
            })( <Input /> )}
          </FormItem>

          <StyledRow gutter={8}>
            <Col span={10} offset={2}>
              <FormItem>
                <Button type='primary' htmlType='submit'>
                  Calculate
                </Button>
              </FormItem>
            </Col>

            <Col span={10}>
              <FormItem>
                <Button onClick={this.handleReset}>
                  Reset
                </Button>
              </FormItem>
            </Col>
          </StyledRow>
        </Form>

      </Card>
    )
  }
}

const CalculatorGreeks = Form.create()(CalculatorGreeksForm)
export default CalculatorGreeks



// WEBPACK FOOTER //
// ./src/components/form-calculator-greeks/index.js